import { FamilyUnit, PossibleEmployerContributionDto } from '@zorro/clients';
import { Title } from '@zorro/design-system/v2/Title';
import { Stack } from '@zorro/web/design-system';

import { ChildBasedTooltipRow } from './ChildBasedTooltipRow';
import { SimpleTooltipRow } from './SimpleTooltipRow';

type AllowanceTooltipContentProps = {
  rangeContributions: PossibleEmployerContributionDto[];
  labelText: string;
  familyUnit?: FamilyUnit;
};

export const AllowanceTooltipContent = ({
  rangeContributions,
  labelText,
  familyUnit,
}: AllowanceTooltipContentProps) => {
  const isChildBased =
    familyUnit === FamilyUnit.EMPLOYEE_CHILD ||
    familyUnit === FamilyUnit.FAMILY;

  const sortedContributions = rangeContributions.sort((aValue, bValue) => {
    const aNum = aValue.numberOfDependents ?? Infinity;
    const bNum = bValue.numberOfDependents ?? Infinity;
    return aNum - bNum;
  });

  return (
    <Stack gap="0.25rem">
      <Title order={3}>Allowance breakdown</Title>
      <Stack gap="0rem">
        {sortedContributions.map((contribution, index) => {
          if (isChildBased) {
            return (
              <ChildBasedTooltipRow
                key={contribution.numberOfDependents ?? 'multiple'}
                contribution={contribution}
              />
            );
          }

          return (
            <SimpleTooltipRow
              // eslint-disable-next-line @eslint-react/no-array-index-key
              key={`${contribution.numberOfDependents ?? 'all'}-${index}`}
              labelText={labelText}
              stipend={contribution.stipend}
              keyValue={`${contribution.numberOfDependents ?? 'all'}-${index}`}
            />
          );
        })}
      </Stack>
    </Stack>
  );
};
